import "core-js/stable";
import "regenerator-runtime/runtime";

import Vue from 'vue';
import VeeValidate, {Validator} from 'vee-validate';
import ValidateNL from './strings/validator/nl.js';

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const veeConfig = {
    errorBagName: 'errors', // change if property conflicts.
    fieldsBagName: 'fields',
    delay: 0,
    locale: 'nl',
    dictionary: null,
    strict: true,
    enableAutoClasses: false,
    classNames: {
        touched: 'touched', // the control has been blurred
        untouched: 'untouched', // the control hasn't been blurred
        valid: 'valid', // model is valid
        invalid: 'invalid', // model is invalid
        pristine: 'pristine', // control has not been interacted with
        dirty: 'dirty' // control has been interacted with
    },
    events: 'input|blur',
    inject: true
};

Validator.localize(ValidateNL);

Vue.use(VeeValidate, veeConfig);

Vue.component('contact-form', () => import('./components/ContactForm.vue'));
Vue.component('quote-form', () => import('./components/QuoteForm.vue'));
Vue.component('search', () => import('./components/Search.vue'));

document.addEventListener('DOMContentLoaded', function () {
    const app = new Vue({
        el: '#app',
    });

    // Get all "navbar-burger" elements
    var $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

    // Check if there are any nav burgers
    if ($navbarBurgers.length > 0) {
        // Add a click event on each of them
        $navbarBurgers.forEach(function ($el) {
            $el.addEventListener('click', function () {

                // Get the target from the "data-target" attribute
                var target = $el.dataset.target;
                var $target = document.getElementById(target);

                // Toggle the class on both the "navbar-burger" and the "navbar-menu"
                $el.classList.toggle('is-active');
                $target.classList.toggle('is-active');
            });
        });
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js